var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticStyle: {
      "height": "100%",
      "display": "flex",
      "flex-direction": "column"
    }
  }, [_c('div', {
    staticStyle: {
      "flex-grow": "1",
      "overflow": "auto"
    }
  }, _vm._l(_vm.editableDocumentTokens, function (editableDocumentTokenPage, pageIndex) {
    return _c('div', {
      key: 'documentTokenPage' + pageIndex
    }, [_c('v-sheet', {
      staticClass: "ma-1",
      staticStyle: {
        "padding": "2px"
      },
      attrs: {
        "id": 'page' + pageIndex,
        "color": _vm.currentPageNumber === pageIndex && _vm.editableDocumentTokens.length > 1 ? 'info' : '',
        "rounded": ""
      }
    }, [_c('v-card', {
      staticClass: "pa-1",
      attrs: {
        "ripple": false,
        "rounded": "",
        "flat": ""
      },
      on: {
        "click": function click($event) {
          return _vm.openPage(pageIndex);
        }
      }
    }, [_vm.editableDocumentTokens.length > 1 ? _c('v-card-title', [_c('span', [_vm._v(" " + _vm._s(_vm.$t("sign.DocumentTemplateDetailTokenList.page")) + " " + _vm._s(pageIndex + 1) + " ")])]) : _vm._e(), editableDocumentTokenPage.length !== 0 ? _c('div', _vm._l(editableDocumentTokenPage, function (token) {
      return _c('v-list-item', {
        key: "".concat(token.coordinates.x, ".").concat(token.coordinates.y),
        staticClass: "ma-0 pa-0"
      }, [!_vm.getIsSignature(token.token) && !_vm.getIsCrossToken(token.token) && token.isEditable ? _c('v-textarea', {
        ref: _vm.getInputRefForIndex(pageIndex, _vm.getIndex(pageIndex, token)),
        refInFor: true,
        staticClass: "ma-1 pa-0",
        attrs: {
          "persistent-hint": "",
          "outlined": "",
          "rows": 1,
          "auto-grow": "",
          "rules": _vm.getRule(token),
          "hint": token.description,
          "label": "".concat(token.title).concat(token && token.isRequired ? ' *' : '')
        },
        on: {
          "blur": _vm.onFieldBlur,
          "focus": function focus() {
            return _vm.onFieldFocus(pageIndex, token);
          }
        },
        model: {
          value: token.value,
          callback: function callback($$v) {
            _vm.$set(token, "value", $$v);
          },
          expression: "token.value"
        }
      }) : _vm.getIsCrossToken(token.token) && token.isEditable ? _c('div', {
        staticClass: "mx-1 mb-2",
        staticStyle: {
          "width": "100%"
        }
      }, [_c('custom-field-boolean', {
        attrs: {
          "value": token.value === _vm.SignatureTokenEnum.CROSS_TOKEN,
          "required": token.isRequired,
          "customField": {
            label: "".concat(token.title || _vm.$t('sign.ReportDocumentSignRequestStepperForm.crossChecked')).concat(token && token.isRequired ? ' *' : '')
          }
        },
        on: {
          "input": function input($event) {
            return _vm.updateCrossToken(token);
          }
        }
      }), _c('div', {
        staticClass: "v-messages__message mt-n7 mx-3 grey--text text--darken-2 text-caption"
      }, [_vm._v(" " + _vm._s(token.description) + " ")])], 1) : _vm._e()], 1);
    }), 1) : _vm._e()], 1)], 1)], 1);
  }), 0)]);
}
var staticRenderFns = []

export { render, staticRenderFns }